import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class FarmService {
    private farmUrl: any;
    constructor(private http: HttpClient) {


        this.farmUrl = environment.API;
    }
    /* GET Plot Detail by ID */

    public getPlotDetailByID(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_DETAIL_PLOT_BY_ID}/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }


    /* GET Control by ID */
    public getControlbyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CONTROL_BY_ID}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* GET Control Camera by ID */
    public getControlCamerabyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CONTROL_BY_ID}Camera`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    /* GET Update Control by ID */
    public getUpdateControlbyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_SENSOR_TYPE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* GET Things all */
    public getSensorByThingsID(id,plot_id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_SENSOR_BY_THING_ID}?thing_id=${id}&plot_id=${plot_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* GET THINGS BY ID */
    public getThingById(farmid, plotid): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_THINGS_BY_ID}/${farmid}/${plotid}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* GET THINGS MENU BY ID */
    public getThingMenuById(farmid, plotid): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_THINGS_BY_ID}Menu/${farmid}/${plotid}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createOnlineConfig(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CREATE_ONLINE_CONFIG}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public updateOnlineConfig(data, online_config_id: string, account_id: string): Observable<any> {
        return this.http.put<any>(`${environment.API}${environment.URL_UPDATE_ONLINE_CONFIG}?online_config_id=${online_config_id}&&account_id=${account_id}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getOnlineConfig(filter?): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_ONLINE_CONFIG}`, {
            params: {
                ...filter
            }
        })
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public getClientConfig(thing_id: string = ""): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_CLIENT_CONFIG}?thing_id=${thing_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* GET UPDATE EMO PLOT BY ID */
    public getUpdateEmobyPlot(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_EMO_BY_PLOT}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* GET UPDATE EMO PLOT BY ID */
    public getAllEmobyPlotAndFarm(farmid, plotid): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_ALL_EMO_BY_PLOT_AND_FARM + "/" + farmid + "/" + plotid}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    /* GET INSERT SCHDUAL/CONDITION BY PLOT AND SENSOR */
    public getInsertScheduleAndCodition(data): Promise<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_INSERT_SCHEDUAL_AND_CONDITION}`, data).toPromise();
    }

    /* GET INSERT SCHDUAL/CONDITION BY PLOT AND SENSOR */
    public getAllScheduleAndCodition(plotid, thingsid, sensorid): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_ALL_SCHEDUAL_AND_CONDITION + "/" + plotid + "/" + thingsid + "/" + sensorid}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }


    /* GET Update ActiveSchedule */
    public getUpdateActiveSchedule(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_ACTIVE_AND_INACTIVE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getDeleteSchedule(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_DELETE_SCHEDULE_AND_CONDITION}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* POST Update Control by ID */
    public getSchedulebyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_SCHEDULE_AND_CONDITION_BY_ID}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    /* POST Update getSchedulebyId by ID */
    public getUpdateSchedulebyId(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_SCHEDULE_AND_CONDITION_BY_ID}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getWeather(data): Observable<any> {

        return this.http.post<any>(`${environment.API}${environment.URL_GET_WEATHER}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getWeathers(data): Observable<any> {

        return this.http.post<any>(`${environment.API}${environment.URL_GET_WEATHER_FORECAST}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }


    public getFarmByName(name): Observable<any> {

        return this.http.get<any>(`${environment.API}${environment.URL_GET_FARM_BY_NAME}?farm_name=${name}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createFarm(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CREATE_FARM}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public updateFarm(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_FARM}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public deleteFarm(farm_id): Observable<any> {
        return this.http.delete<any>(`${environment.API}${environment.URL_DELETE_FARM}/${farm_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createZone(data): Observable<any> {
        return this.http.post<any>(`${this.farmUrl}${environment.URL_CREATE_NEW_ZONE}`, data)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public createNewPlot(formData): Observable<any> {
        return this.http.post<any>(`${this.farmUrl}${environment.URL_CREATE_NEW_PLOT}`, formData)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public updateNewPlot(formData): Observable<any> {
        return this.http.post<any>(`${this.farmUrl}${environment.URL_UPDATE_NEW_PLOT}`, formData)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public deletePlot(plot_id): Observable<any> {
        return this.http.delete<any>(`${this.farmUrl}${environment.URL_DELETE_PLOT}/${plot_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getPlotByName(name): Observable<any> {

        return this.http.get<any>(`${this.farmUrl}${environment.URL_GET_PLOT_BY_NAME}?plot_name=${name}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createRealTimeCamera(data): Observable<any> {
        return this.http.post<any>(`${this.farmUrl}${environment.URL_CREATE_REALTIME_CAMERA}`, data)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public updateRealTimeCamera(data): Observable<any> {
        return this.http.post<any>(`${this.farmUrl}${environment.URL_UPDATE_REALTIME_CAMERA}`, data)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public getZone(id): Observable<any> {

        return this.http.get<any>(`${this.farmUrl}${environment.URL_GET_ZONE}?zone_id=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public deleteZone(zone_id): Observable<any> {
        return this.http.delete<any>(`${environment.API}${environment.URL_DELETE_ZONE}/${zone_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public updateZone(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_ZONE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    
    public getThingMGL(filter?): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_THING_MGL}`, {
            params: {
                ...filter
            }
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getThingMenuMGL(filter?): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_THING_MGL}Menu`, {
            params: {
                ...filter
            }
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getSensorType(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_SENSOR_TYPE}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getThingByThingId(filter): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_THING_BY_THING_ID}`, {
            params: { ...filter },
          })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createThing(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CREATE_THING}`, data)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public updateThing(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_THING}`, data)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public createSensor(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CREATE_SENSOR}`, data)
        .pipe(
            catchError(error => {
                return of(error.error);
            }));
    }

    public updateSensor(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_SENSOR}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public deleteThing(thing_id, plot_id): Observable<any> {
        return this.http.delete<any>(`${environment.API}${environment.URL_DELETE_THING}/${thing_id}/${plot_id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getAllSensorByThingsID(id,plot_id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_SENSOR_BY_THING_ID}?thing_id=${id}&plot_id=${plot_id}&all=true`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getMedia(thing_id, filter): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_MEDIA}/${thing_id}`,
        {
            params: filter
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getCamera(thing_id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_CAMERA}/${thing_id}`,)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
}